export const buildClassnames = (names: (string | undefined)[]): string =>
  names.filter(Boolean).join(' ');
